export const imageConfigurations = [
  {
    width: 42,
    height: 28,
    quality: 10,
    resize: 'FILL_DOWN',
  },
  {
    // Small Card: desktop * 1 dpi
    width: 335, height: 223, resize: 'FILL_DOWN',
  },
  {
    width: 469, height: 313, resize: 'FILL_DOWN',
  },
  {
    width: 502, height: 335, resize: 'FILL_DOWN',
  },
  {
    // Big Card: desktop * 1 dpi
    width: 570, height: 380, resize: 'FILL_DOWN',
  },
  {
    width: 621, height: 414, resize: 'FILL_DOWN',
  },
  { width: 670, height: 447, resize: 'FILL_DOWN' },
  {
    // Big/Small Card: mobile * 2 dpi
    width: 720, height: 480, resize: 'FILL_DOWN',
  },
  { width: 1242, height: 828, resize: 'FILL_DOWN' },
];

export const spotlightVariables = {
  featured: true,
  offset: 0,
  limit: 1,
  tagSlug: 'spotlight',
  inDays: 1,
  imageConfigurations,
};

const featuredVariables = {
  featured: true,
  offset: 0,
  limit: 4,
  sort: 'CREATED_AT',
  statuses: ['PUBLISHED'],
  imageConfigurations,
};

export default featuredVariables;
